'use client'
import { Navbar } from '@/components/Navbar'
import { Footer } from '@/components/footer'

export default function LangLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
			<Navbar />
				{children}
			<Footer />
		</>
  )
}